/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Cta_Docs_LinkInputs */

const en_marketing_cta_docs_link = /** @type {(inputs: Marketing_Cta_Docs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or start with the docs`)
};

const es_marketing_cta_docs_link = /** @type {(inputs: Marketing_Cta_Docs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O empieza por la documentación`)
};

const fr_marketing_cta_docs_link = /** @type {(inputs: Marketing_Cta_Docs_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou commencez par la documentation`)
};

/**
* | output |
* | --- |
* | "Or start with the docs" |
*
* @param {Marketing_Cta_Docs_LinkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_cta_docs_link = /** @type {((inputs?: Marketing_Cta_Docs_LinkInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Cta_Docs_LinkInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_cta_docs_link(inputs)
	if (locale === "es") return es_marketing_cta_docs_link(inputs)
	return fr_marketing_cta_docs_link(inputs)
});